export default {
    waitingArea:'待降区域',
    guidedLanding:'引导降落',
    landHeight:'待降高度',
    conversionHeight:'转换高度',
    flySpeed:'飞行速度',
    entryDirection:'进场方向',
    landingPosition:'降落点位置',
    mapPosition:'地图选点',
    uavPosition:'使用无人机当前位置',
    landingParameters:'降落参数',
    landingPointAltitude:'降落点海拔',
    recyclingLandingParameters:'动态回收降落参数',
    waitingAreaRadius:'待降区半径',
    waitingAreaHeight:'待降区相对高度',
    waitingAreaDistance:'待降区到降落点的距离',
    guidanceSpeed:'引导段速度',
    goAroundHeight:'复飞爬升高度',
    recyclingExpandParameters:'动态回收拓展参数',
    conversionPointHeight:'转换点高度',
    otherModels: '其它机型',
    HUTF: '垂起固定翼',
    upgrading: '正在升级',
    //header部分
    set: '地面站设置',
    logout: '退出登录',
    noSignal: '无信号',
    setting: '设置',
    news: '消息',
    user: '用户',
    em: '设备管理',
    dataLink: '数据链',
    connected: '已连接',
    notConnected: '未连接',
    strongSignal: '信号强',
    weakSignal: '信号弱',
    windSpeed: '风速',
    windDirection: '风向',
    temperature: '温度',
    humidity: '湿度',
    airPressure: '气压',
    weatherStation: '气象站',
    urgent: '紧急',
    high: '高',
    medium: '中',
    low: '低',
    usedFlow: '已用流量',
    residualFlow: '剩余流量',
    page: '{index}D 页面',
    //辅助信息部分
    errMsg: '错误信息',
    moreTools: '更多工具',
    flightMode: '飞行模式',
    targetPoint: '下一航点',
    distance: '距离',
    currentPOS: '当前位置：',
    fail: '获取信息失败',
    normal: '一切正常可以起飞',
    debugging: '调试助手',
    flightLog: '飞行日志',
    sensor: '传感器校准',
    journal: '飞行日志',
    devTools: '开发者工具',
    flightTime: '飞行时间',
    flightDistance: '飞行距离',
    generalConfig: '通用配置',
    RTKSettings: 'RTK设置',
    AC: '加速度计校准',
    CC: '指南针校准',
    RC: '摇杆校准',
    LC: '水平校准',
    VC: '垂直校准',
    MT: '马达测试',
    getList: '获取列表',
    snatchSession: '抢夺会话',
    downloadMachine: '下载本机',
    cancelDownload: '取消下载',
    downloadAgain: '重新下载',
    size: '大小',
    batteryInformation: '电池信息',
    batteryType: '电池类型',
    electricity: '电量',
    voltage: '电压',
    current: '电流',
    notAcquired: '未获取',
    productionDate: '生产日期',
    parachuteSelfCheckStatus: '降落伞自检状态',
    parachuteOpeningStatus: '降落伞开伞状态',
    selfCheckPassed: '自检通过',
    selfTestFailed: '自检未通过',
    locked: '已锁定',
    unlocked: '已解锁',
    umbrellaOpened: '已开伞',
    // speed:'速度',
    enter: '进入',
    download: '下载',
    //工具栏
    uavList: '无人机列表',
    map: '地图',
    video: '视频',
    taskManagement: '任务管理',
    fastTask: '快速任务',
    quickPuzzle: '快速拼图',
    achievementDisplay: '成果展示',
    tagManagement: '标记管理',
    electronicFence: '电子围栏',
    CT: '坐标转换',
    degrees: '度数',
    DMS: '度分秒',
    measuring: '测量',
    waypointEditor: '航点编辑',
    routeEditor: '航线编辑',
    routeTemplate: '航线模板',
    arbitraryFlight: '指点飞行',
    clearTrajectory: '清除轨迹',
    DOH: '双光云台',
    megaphone: '喊话器',
    LS: '载荷设置',
    VFS: '视频全屏',
    pictureLayout: '画面布局',
    PTZSetting: '云台设置',
    clearMeasurementLayer: '清除测量图层',
    formationFlying: '编队飞行',
    robotDog: '机器狗',
    //航点编辑
    reverse: '逆序',
    cycles: '循环次数',
    height: '高度',
    speed: '速度',
    waypointMode: '航点模式',
    turnMode: '转弯模式',
    radius: '半径',
    altitude: '海拔',
    time: '时间',
    editWP: '航点修改',
    editPosition: '坐标修改',
    azimuth: '方位角',
    editDirection: '方位修改',
    complete: '添加完成',
    added: '添加航点',
    insert: '插入航点',
    save: '保存到航线列表',
    openRouteList: '打开航线列表',
    open: '打开',
    del: '删除航点',
    revoke: '撤销',
    redo: '重做',
    home: '归航',
    editHome: '归航修改',
    editComplete: '修改完成',
    goHome: '执行归航',
    noHome: '归航点未规划',
    circlingDirection: '盘旋方向',
    clockwise: '顺时针',
    counterclockwise: '逆时针',
    liftMode: '升降模式',
    liftImmediately: '立即升降',
    highProtection: '高度保护',
    circlingRadius: '盘旋半径',
    readHoming: '读取归航',
    nosePointing: '机头指向',
    followTheRoute: '跟随航线',
    target: '目标点',
    courseModification: '航向修改',
    device: '设备',
    action: '动作',
    serialNumber: '编号',
    routeClosed: '航线闭合',
    export: '导出{0}',
    import: '导入{0}',
    position: '定位',
    upload: '上传',
    imageSwitching: '图像切换',
    rowsColumns: '检测到：{rows}行，{cols}列',
    latLngStart: '经纬度开始行',
    column: '{0}所在列',
    whichColumn: '第{0}列',
    LPRM: '车牌识别模式',
    batchEdit: '批量修改',
    //航线编辑
    routeNumber: '航线编号',
    routeHeight: '全局航线高度',
    routeSpeed: '全局航线速度',
    remainingTimes: '剩余次数',
    routeEndAction: '结束动作',
    routeEntryPoint: '航线切入点',
    routeLength: '航线长度',
    estimatedFlightTime: '预计飞行时间',
    rotation: '旋转',
    translation: '平移',
    //航线模板
    triangle: '三角形',
    rectangle: '矩形',
    polygone: '多边形',
    round: '圆形',
    scan: '扫描',
    sideLength: '边长',
    RH: '高度',
    startToEnd: '闭合',
    length: '长',
    width: '宽',
    number: '数量',
    addArea: '添加区域',
    scanAngle: '扫描角度',
    scanInterval: '扫描间隔',
    scanArea: '扫描面积',
    Import: '导入航点编辑器',
    inSurvey: '测量中，请先结束测量',
    scanIntervalFormat: '扫描间隔最小为1',
    STA: '扫描该区域',
    repaint: '重绘',
    photoShootingMethod: '拍照方式',
    photoInterval: '拍照间隔',
    //指点飞行
    hoverTime: '等待时间',
    timeoutAC: '超时动作',
    enterPointingFlightMode: '进入指点飞行模式',
    exitAdvice: '退出指点飞行模式',
    startExecution: '开始执行',
    noPointing: '请先规划指点飞行位置',
    pointingFlight: '指点飞行',
    isPointingFlight: '是否开始指点飞行?',
    IAL: '0是一直循环',
    pointingDistance: '指点距离',
    returnFlight: '返航',
    landing: '降落',
    //航线列表
    routeList: '航线列表',
    routeName: '航线名',
    search: '搜索',
    createTime: '创建时间',
    operation: '操作',
    use: '使用',
    noUaerid: '用户ID为空',
    share: '分享',
    merge: '合并',
    dragSort: '拖动排序',
    routeRemarks: '航线备注',
    relativeAltitudeRoute: '相对高度航线',
    altitudeRoute: '海拔高度航线',
    PETN: '长度0~100个字符',
    //操作按钮
    endPperation: '结束试飞',
    takeoverControl: '收回控制',
    releaseControl: '释放控制',
    uavLocation: '飞机定位',
    executionRoute: '航线飞行',
    takeOff: '自动起飞',
    flightSuspension: '暂停飞行',
    flightContinue: '继续飞行',
    land: '降落',
    directReturn: '直接返航',
    trackReturn: '原路返航',
    manual: '手动控制',
    emergencyStop: '紧急停机',
    loadControl: '载荷控制',
    SC: '速度控制',
    HC: '高度控制',
    NOU: '无人机数量',
    DP: '默认切入点',
    CSQ: '当前选中数量',
    TOS: '起飞顺序',
    meanwhile: '同时起飞',
    delayed: '延时起飞',
    delayedTakeoff: '延时起飞',
    emergency: '应急',
    RTF: '待飞',
    unlock: '解锁',
    takeoff: '起飞',
    route: '航线',
    waypoint: '航点',
    cycle: '循环',
    unlimited: '无限',
    EATN: '结束后进入',
    homingHovering: '归航盘旋',
    homingLanding: '归航降落',
    CLR: '转换降落航线',
    executeImmediately: '立即执行',
    returnHome: '归航',
    flightControl: '飞行调节',
    standardLanding: '制式降落',
    MRL: '多旋翼原地降落',
    MRQRL: '多旋翼返航降落',
    FWA: '固定翼备降',
    sprayOn: '喷洒开',
    sprayOff: '喷洒关',
    moreInstructions: '更多指令',
    spraySetting: '喷洒设置',
    typesOf: '类型',
    WPL: '水泵-左',
    WPR: '水泵-右',
    WPF: '水泵全',
    NV: '数值',
    actionOn: '动作开',
    actionOff: '动作关',
    startPuzzle: '开始拼图',
    endPuzzle: '结束拼图',
    aisle: '通道',
    left: '左',
    right: '右',
    proportion: '比例',
    return: '返回',
    airlineFlight: '航线飞行',
    routePerformed: '需要执行的航线',
    entryPoint: '切入点',
    waitExecutionTime: '等待执行时间',
    entryPointError: '切入点输入错误',
    intervalSendTime: '间隔发送时间',
    deviceFunction: '设备功能',
    configure: '配置',
    without: '无',
    gimbalDown: '云台向下',
    gimbalReset: '云台复位',
    followMode: '跟随模式',
    courseLock: '航向锁定',
    freeMode: '自由模式',
    MRLIP: '多旋翼原地降落',
    MRFRL: '多旋翼返航降落',
    rotorAlternate: '旋翼备降',
    fixedWingAlternate: '固定翼备降',
    startFromThePointcut: '从切入点开始',
    startFromTheStartingPoint: '从起始点开始',
    executionOrder: '执行顺序',
    heightAdjustment: '高度调节',
    speedAdjustment: '速度调节',
    reset: '复位',
    oneKeyDown: '一键向下',
    followTheAircraftHead: '跟随机头',
    // 通用配置
    ATOWR: '允许无RTK起飞',
    CM: '爬升模式',
    tilt: '倾斜爬升',
    vertical: '垂直爬升',
    cycleMode: '循环模式',
    BP: '切入点',
    SP: '起始点',
    RA: '返航高度',
    HL: '高度限制',
    RS: '返航速度',
    returnHomingDirection: '返航/归航方向',
    headOrientation: '机头朝向',
    tailOrientation: '机尾朝向',
    securitySetting: '安全设置',
    TOWPIA: '允许无降落伞起飞',
    AWAF: '航点动作失败后',
    continueTheRoute: '继续航线',
    waitFor: '等待',
    RCOOCP: '遥控器失控保护',
    linkRunawayProtection: '链路失控保护',
    NA: '无动作',
    hover: '悬停',
    returnH: '返航(直线返航)',
    EA: '电量报警',
    FLA: '一级报警',
    EQ: '电量',
    PS: '保护策略',
    SALA: '声光告警',
    SA: '二级报警',
    aileron: '副翼',
    lift: '升降',
    accelerator: '油门',
    direction: '方向',
    airplaneMode: '飞行模式',
    output: '输出',
    test: '测试',
    channelTest: '通道测试',
    singleShot: '单拍',
    continuousShooting: '连拍',
    oneShot: '单次拍照',
    burstStarts: '连拍开始',
    burstEnds: '连拍结束',
    pitch: '俯仰',
    roll: '横滚',
    yaw: '航向',
    flowRate: '流速',
    minimum: '最小值',
    maximum: '最大值',
    automatic: '自动',
    close: '关闭',
    currentChannel: '当前通道',
    trigger: '触发',
    flightParameters: '飞行参数',
    heightLimit: '遥控器高度限制',
    flightSpeed: '遥控器飞行速度',
    outputChannelBinding: '输出通道绑定',
    inputChannelMapping: '输入通道映射',
    protectiveFunction: '保护功能',
    flightInspection: '飞行检查',
    sensorStatus: '传感器状态',
    thrustTest: '推力测试',
    turnOffImmediately: '立即熄火',
    abortAction: '中止动作',
    rotorReadyToTakeOff: '旋翼准备起飞',
    rotorAttitudeThrottle: '旋翼姿态油门',
    rotorPositioningRemoteControl: '旋翼定位遥控',
    FWRS: '固定翼舵面遥控',
    FWAR: '固定翼姿态遥控',
    joystickStatus: '摇杆状态',
    magneticCompass: '磁罗盘',
    japaneseHand: '日本手',
    americanHand: '美国手',
    chineseHand: '中国手',
    antiJapaneseHand: '反日本手',
    dataLinkConnection: '数据链连接',
    internalGNSSSystem: '内部GNSS系统',
    rockerConnection: '摇杆连接',
    externalGNSSSystem: '外部GNSS系统',
    flightControlMode: '飞控模式',
    navigationState: '导航状态',
    fixedWingThrottle: '固定翼油门',
    rotorThrottle: '旋翼油门',
    ATP: '自动起飞参数',
    presetClimbAltitude: '预设爬升高度',
    fixedWing: '固定翼',
    multiRotor: '多旋翼',
    timeProtection: '航时保护',
    protectionMethod: '保护方式',
    notProtected: '不保护',
    protectionTime: '保护航时',
    // 云台
    SR1: '开始录像',
    SR2: '停止录像',
    photograph: '拍照',
    zoom: '变焦',
    IAOR: '航线内角',
    targetLock: '目标锁定',
    targetUnlock: '目标解锁',
    infraredSwitching: '红外切换',
    recordingNotTurnedOn: '未打开录音',
    solveTargetPosition: '解算目标位置',
    startTargetRecognition: '开始目标识别',
    stopTargetRecognition: '停止目标识别',
    targetRecognitionStatistics: '目标识别统计',
    videoFrameSelection: '视频框选',
    confirmTracking: '确认追踪',
    licensePlateRecognition: '车牌识别',
    getFlightControl: '获取飞行控制权',
    // 车牌识别
    pictureList: '图片列表',
    shootingDate: '拍摄日期',
    unrecognized: '未识别',
    sameDay: '当天',
    twoDays: '两天',
    threeDays: '三天',
    aWeek: '一周',
    // 喊话器
    startRecording: '开始录音',
    playRecording: '播放录音',
    volume: '音量',
    // 画面设置
    resolutionSetting: '画面设置',
    videoStreaming: '视频推流',
    format: '格式',
    resolution: '分辨率',
    codeRate: '码率',
    // 高程信息
    elevationInformation: '高程信息',
    numbering: '编号',
    details: '详情信息',
    // 电子围栏
    model: '模式',
    polygonElectricFence: '多边形电子围栏',
    startPicking: '开始采点',
    endPicking: '结束采点',
    clearPicking: '清除采点',
    read: '读取',
    // 载荷
    megaphoneLoad: '喊话器载荷',
    play: '播放',
    selectFile: '选取文件',
    siren: '警笛',
    textPlay: '文本播放',
    // 任务成果
    taskOutcome: '任务成果',
    taskName: '任务名称',
    aerialSurveyMission: '航测任务',
    taskType: '任务类型',
    startAndEndTime: '起止时间',
    start: '开始',
    end: '结束',
    address: '地址',
    generateTarget: '生成目标',
    // 生命探测、手机频谱
    lifeDetection: '生命探测',
    uavName: '无人机名称',
    flightAltitude: '飞行高度',
    signalDistance: '信号距离',
    confirm: '确认',
    suspected: '疑似',
    collectionTime: '采集时间',
    positionCoordinates: '位置坐标',
    signalStrength: '信号强度',
    strongest: '最强',
    realTime: '实时',
    startDetection: '开始探测',
    endDetection: '结束探测',
    // 编队飞行
    formationMainRouteEdit: '编队主航线编辑',
    totalNumberFormations: '编队总架数',
    executeNextRoute: '执行下条航线',
    delayActionTime: '延迟动作时间',
    formationEditor: '队形编辑',
    saveFormationFile: '保存编队文件',
    formationFileList: '编队文件列表',
    uploadFormationRoute: '上传编队航线',
    uavNumber: '无人机编号',
    formationFileName: '编队文件名称',
    editName: '编辑名称',
    editFile: '编辑文件',
    cellDistance: '单元格距离',
    offsetDirectionAngle: '偏移方向角',
    axisOffset: '{name}轴偏移量(米)',
    formation: '{msg}队形',
    topView: '俯视图',
    rightView: '右视图',
    frontView: '主视图',
    // RTK设置
    rtkFrontView: 'RTK当前状态',
    normalOK: '正常',
    noService: '无服务',
    dataForwardingType: '数据转发类型',
    BAUOBS: '基站的绑定与解绑',
    encryptionMode: '加密模式',
    publicMode: '公开模式(无密码)',
    linkingPassword: '对频密码',
    ntripHostAddress: 'NtripHost地址',
    port: '端口号',
    username: '用户名',
    password: '密码',
    mountPoint: '挂载点',
    notUsingRTK: '不使用RTK',
    confirmAdjustment: '确认调整',
    standardNetwork: '标准网络',
    otherNetwork: '其他网络',
    localNetwork: '本地网络',
    customNetwork: '自定义网络',
    doNotUse: '不使用',
    allocationConfirmation: '分配确认',
    allocationSuccessful: '分配成功',
    allocationFailed: '分配失败',
    aiRecognitionStatistics: 'AI识别统计',
    pedestrian: '行人',
    vehicle: '车辆',
    imageZoom: '图像放大',
    imageReduction: '图像缩小',
    // 提示
    tips_routerSportNumber: '请至少规划两个航点',
    tips_MD: '测量图层删除成功',
    tips_MStart: '测量开始',
    tips_MEnd: '测量结束',
    tips_noSelectUAV: '未选中无人机，是否切换为离线模式?',
    tips_noSelectRS: '请选择一个航点',
    tips_SelectRS: '请至少选择一个航点',
    tips_errA: '{uav} 存在 {err} 级故障,请尽快处理',
    tips_inputError: '{name}输入错误',
    tips_HInputError: '高度输入错误',
    tips_SInputError: '速度输入错误',
    tips_SO: '操作成功',
    tips_AF: '添加完成',
    tips_isD: '是否确定删除?',
    tips_loopErr: '循环次数输入错误!',
    tips_Upload: '已上传至服务器!',
    tips_RName: '长度在1~20个字符',
    tips_noRoute: '请先规划航线',
    tips_ALT: '请至少规划两个航点',
    tips_IEP: '切入点输入不正确',
    tips_PEP: '请输入切入点',
    tips_endspot: '最后一个航点只能是降落，返航或者归航',
    tips_planFailure: '航点规划错误',
    tips_crosNoFly: '航线不能穿过禁飞区，请重新规划',
    tips_RTRF: '航线穿过限飞区(高度<=300m)，请重新规划',
    tips_IIPT: '飞行中可能穿过禁飞区，请重新规划',
    tips_homingNoFly: '归航点不能在禁飞区内，请重新规划',
    tips_HPEF: '归航点必须在电子围栏内，请重新规划',
    tips_PFNoFly: '指点飞行不能在禁飞区内，请重新规划',
    tips_PFEF: '指点飞行必须在电子围栏内，请重新规划',
    tips_EFNoFly: '航线必须在电子围栏内，请重新规划',
    tips_enterAreaMeas: '请输入面积测量图层描述内容',
    tips_takeOver: '拥有者已收回控制权',
    tips_endTakeOver: '您的此次试飞已经结束，是否退出?',
    dist: '距离',
    relativeDist: '相对距离',
    angle: '角度',
    relativeAngle: '相对角度',
    tip_AETMCA: '高度超过最大巡航高度',
    tip_TRETMSR: '半径超过最大安全半径',
    // 校准提示
    tip_CC: '校准已完成',
    tip_ESCTC: '输入SN码进行确认',
    tip_ICAYSTC: '校准中，是否确定取消？',
    tip_UIFPTAL: '无人机飞行中，请稍后重试',
    tip_KAFEIAC: '校准开始后，请远离电磁干扰',
    tip_DNMTAACB: '校准开始后，请勿动飞机',
    tip_BSTRAPFT: '请务必拆除所有螺旋桨进行测试',
    tip_PKTPLITFD: '请保持飞机正向水平放置',
    tip_PKTNDAV: '请保持机头向下垂直放置',
    tip_PKTNU: '请保持机头向上垂直放置',
    tip_PKTLSOTAFDV: '请保持飞机左侧面向下垂直放置',
    tip_PKTRSOTAFDV: '请保持飞机右侧面向下垂直放置',
    tip_PKTPIRAHP: '请保持飞机反向水平放置',
    tip_PKTPLARAA: '请先将无人机保持水平匀速旋转3圈，然后水平翻转180°呈倒置状态，再次匀速旋转3圈',
    tip_PKTLSOTPFDARAACS: '请保持飞机左侧面向下，匀速转动',
    tip_PKTANUARAACS: '请保持飞机头向上，匀速转动',
    tip_PKARCP: '请保持所有遥杆中立，点击开始进行遥控器校准',
    tip_PTTRET: '请均匀转动摇杆接触极限位置',
    tip_PKAPN: '请保持所有遥杆中立',
    tip_PKTNS: '请保持机头静止向上，水平角度大于70°',
    tip_VL: '视频加载中',
    // 通用配置提示
    tip_RACBE: '返航高度不能为空',
    tip_PEANV: '请输入整数',
    tip_RAMBG: '返航高度必须大于等于5',
    tip_TRAMB: '返航高度必须小于高度限制',
    tip_HLCBE: '高度限制不能为空',
    tip_HLR: '高度限制范围3~500',
    tip_RSCBE: '返航速度不能为空',
    tip_RSR: '返航速度范围2~10',
    tip_SDT: '模拟无人机超时',
    tip_LAL: '经纬度输入错误，请重新输入',
    tip_enterHeading: '请输入航向角度',
    tip_addTargetPoint: '请添加目标点',
    tip_WACO: '航点动作一次只能修改一个航点',
    tip_selectDev: '请选择设备',
    tip_selectAction: '请选择动作',
    tip_enterInte: '请输入整数',
    tip_TSVO: '动作参数最小值为',
    tip_TMVOT: '动作参数最大值为',
    tip_enterAction: '请输入动作参数',
    tip_TIAB: '当前航线有断点，是否从断点飞行？',
    tip_TDWA: '无人机将自动起飞悬停，请输入悬停高度(1~200整数)',
    tip_HHIE: '悬停高度输入错误',
    tip_enterImgSwitching: '请输入图像切换的PWM值',
    tip_enterSinglePhoto: '请输入单次拍照的PWM值',
    tip_enterStartCS: '请输入连拍开始的PWM值',
    tip_enterEndCS: '请输入连拍结束的PWM值',
    tip_TPVF: '连拍开始和结束的PWM值不能相等',
    tip_enterAngle: '请输入角度值',
    tip_enterPWM: '请输入PWM值',
    tip_PWMVCBE: 'PWM值不能相等',
    tip_PWMCBE: 'PWM不能为空',
    tip_FRCB: '流速不能为空',
    tip_TMVO: 'PWM最小值要小于最大值',
    tip_TMVOF: '流速最小值要小于最大值',
    tip_enterPWMoff: '请输入关闭的PWM值',
    tip_enterPWMon: '请输入打开的PWM值',
    tip_OAOP: '关闭和打开的PWM值不能相等',
    tip_EPSR: '请输入开始录像的PWM值',
    tip_EPER: '请输入结束录像的PWM值',
    tip_TPVOS: '开始录像和结束录像的PWM值不能相等',
    tip_APEF: '多边形电子围栏最少要三个点',
    tip_TSAR: '扫描角度范围为-360~360',
    tip_ANWS: '边长为大于0的数字',
    tip_LIAN: '长为大于0的数字',
    tip_WIAN: '宽为大于0的数字',
    tip_ANWA: '半径为大于0的数字',
    tip_PITV: '请输入值',
    tip_TIDTD: '航线编辑器里面有不符合格式的数据',
    tip_TIMTO: '当前勾选的无人机列表超过一个，无法设置切入点，默认为1。',
    tip_fileError: '文件错误，请检查文件内容是否正确',
    tip_pleaseEnterKeyword: '请输入关键词',
    tip_REAEM: '航线编辑器:高度超过最大巡航高度',
    tip_REREM: '航线编辑器:半径超过最大安全半径',
    tip_TWTOUA: '无人机收到指令后等待的时间',
    tip_ISTOCC: '控制指令的间隔发送时间',
    tip_YCDTLY: '可上下拖动列表对无人机的执行顺序进行排序',
    tip_PSTRTB: '请选择需要执行的航线',
    tip_PMST: '请确保生命探测设备已经连接无人机！',
    tip_TDPT: '探测过程每次需要5-10分钟，请注意观察探测数据！',
    tip_TNOA: '编队架数为0，请输入编队架数！',
    tip_TMRI: '主航线为空，请规划主航线！',
    tip_PETF: '请输入编队文件名称',
    tip_EBSN: '输入基站编号检索',
    tip_TPBS: '第三方基站需联系管理员开通或关闭',
    tip_TRSH: '该RTK服务已分配至无人机(SN：{id1})，是否调整至当前无人机(SN：{id2})，确认后原有无人机将不再接收网络RTK差分数据。',
    tip_ANRA: '已为当前飞行器分配其他网络RTK账号(服务号：{rtkKey})，可正常获取差分数据。',
    tip_TRSI: '该RTK服务未激活，无法获取差分数据。',
    tip_TRSHE: '该RTK服务已过期，无法获取差分数据。',
    tip_FEPE: '格式错误，请输入1-65535的整数！',
    tip_PCALP: '请选择降落点',
    tips_THPMB: '归航点必须在电子围栏内，请重新规划',
    tips_PETT: '请输入目标ID',
    tips_ITCR: '是否覆盖当前航线？',
    tips_DTCP: '拖拽改变位置',
    tips_HDTA: '按住Alt键上下拖拽改变高度',
    tips_ASPT: '选中之后按Delete键删除',
    tips_TDCB: '无人机不能重复，请重新选择！',
    tips_TVSC: '视频源不能重复，请重新选择！',
    tips_WAHA: '航点{number}已有等时拍照动作，请勿重复添加。',
    tips_WAHAE: '航点{number}已有等距拍照动作，请勿重复添加。',
    tips_PETP: '请输入图像放大的PWM值',
    tips_PETPR: '请输入图像缩小的PWM值',
    tips_TPVF: '图像放大和图像缩小的PWM值不能相等',
}